import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const PriceStrategyLazy = loadable(() => import(/* webpackChunkName: "PriceStrategy" */ './PriceStrategySuspense'));

export const PriceStrategyAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <PriceStrategyLazy />
    </DelayedSuspense>
);
